module.exports = __webpack_public_path__ + "img/sj.5f7461f7.png";